import React, { useContext, useEffect, useState } from "react";
import { getApi, postApi } from "../../services/api/globalApi";
import { Field, Form, Formik } from "formik";
import { motion } from "framer-motion"
import { toast } from "react-toastify";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { digitsThree } from "../../utils/price";
import { context } from "../../context/context";


const LoansFormula = () => {

    const { showLogutModal} = useContext(context)

    const [loan, setLoan] = useState(null)

    const getCurrentLoan = async () => {
        try {
            const data = await getApi({ path: "loansFormula/new" })
            console.log(data.data.data)
            setLoan(data.data.data)

        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        getCurrentLoan()
    }, [])

    function clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
                delete obj[propName];
            }
        }
        return obj
    }

    const formHandler = async (values, { resetForm }) => {

        const newValues = clean(values);
        try {
            const body = JSON.stringify(newValues)

            const response = await postApi({
                path: 'admin/loansFormula/createOrUpdate',
                body: body
            });
            toast.success("تغییرات با موفقیت ثبت شد.", {
                position: "top-right",
                closeOnClick: true
            });
            resetForm()
            getCurrentLoan()

        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.errors.message, {
                position: "top-right",
                closeOnClick: true
            });
            error?.response.status == 401 && showLogutModal();
        }
    }

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.5,
                // ease: [0, 0.71, 0.2, 1.01]
            }} className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6">

            <h6 className="mb-6 mt-2 text-gray-800 dark:text-white flex gap-x-2 items-center">
                <span className="flex items-center justify-center text-lg text-white">
                    <svg fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="h-6 w-6">
                        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
                    </svg>
                </span>
                 خرید و فروش امتیاز
            </h6>

            <div className="dark:text-white w-11/12 mx-auto mt-4">
                <div className="flex w-full items-center justify-center flex-wrap pz-10 gap-4">
                    <div class="bg-gradient-to-b from-yellow-500 dark:from-yellow-700 to-yellow-200 dark:to-yellow-400 border-b-4  border-yellow-600 dark:border-yellow-900 rounded-lg shadow-xl p-5">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pl-4">
                                <div class="rounded-full p-5 bg-yellow-600 dark:bg-yellow-900">
                                    <FaMoneyBillTrendUp size={30} />
                                </div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold">قیمت نقدی خرید امتیاز</h5>
                                <h3 class="font-bold text-2xl mt-2">{loan ? digitsThree(loan.cashBuyRate) : null}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gradient-to-b from-yellow-500 dark:from-yellow-700 to-yellow-200 dark:to-yellow-400 border-b-4  border-yellow-600 dark:border-yellow-900 rounded-lg shadow-xl p-5">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pl-4">
                                <div class="rounded-full p-5 bg-yellow-600 dark:bg-yellow-900">
                                    <FaMoneyBillTrendUp size={30} />
                                </div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold">قیمت عرفی خرید امتیاز</h5>
                                <h3 class="font-bold text-2xl mt-2">{loan ? digitsThree(loan.commonBuyRate) : null}</h3>
                            </div>
                        </div>
                    </div>
                   <div class="bg-gradient-to-b from-green-500 dark:from-green-700 to-green-200 dark:to-green-400 border-b-4 border-green-600 dar:border-green-900 rounded-lg shadow-xl p-5">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pl-4">
                                <div class="rounded-full p-5 bg-green-600 dark:bg-green-900">
                                    <FaMoneyBillTrendUp size={30} />
                                </div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold">قیمت فعلی فروش نقدی</h5>
                                <h3 class="font-bold text-2xl mt-2">{loan ? digitsThree(loan.number) : null}</h3>
                            </div>
                        </div>
                    </div>
                   <div class="bg-gradient-to-b from-green-500 dark:from-green-700 to-green-200 dark:to-green-400 border-b-4 border-green-600 dar:border-green-900 rounded-lg shadow-xl p-5">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pl-4">
                                <div class="rounded-full p-5 bg-green-600 dark:bg-green-900">
                                    <FaMoneyBillTrendUp size={30} />
                                </div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold">قیمت فعلی فروش چکی</h5>
                                <h3 class="font-bold text-2xl mt-2">{loan ? digitsThree(loan.chequeNumber) : null}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gradient-to-b from-indigo-500 dark:from-indigo-700 to-indigo-200 dark:to-indigo-400 border-b-4  border-indigo-600 dark:border-indigo-900 rounded-lg shadow-xl p-5">
                        <div class="flex flex-row items-center">
                            <div class="flex-shrink pl-4">
                                <div class="rounded-full p-5 bg-indigo-600 dark:bg-indigo-900">
                                    <FaMoneyBillTrendUp size={30} />
                                </div>
                            </div>
                            <div class="flex-1 text-right md:text-center">
                                <h5 class="font-bold">اختلاف قیمت ماه ها</h5>
                                <h3 class="font-bold text-2xl mt-2">{loan ? digitsThree(loan.difference) : null}</h3>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="flex gap-x-8 mt-6">
                    <div className="w-full flex gap-x-6">
                        <Formik
                            initialValues={{
                                number: '',
                                chequeNumber: '',
                                difference: '',
                                cashBuyRate: '',
                                commonBuyRate: '',
                            }}
                            // validationSchema={validate}
                            onSubmit={formHandler}

                        >
                            {(formik) => (
                                <Form className="w-full">
                                    <h4 className="mb-6">قیمت جدید را وارد کنید</h4>
                                    <div className="grid gap-6 mb-6 md:grid-cols-2">
                                        <div>
                                            <label for="cashBuyRate" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">قیمت نقدی خرید امتیاز</label>
                                            <Field autocomplete="off" type="text" name="cashBuyRate" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="قیمت نقدی خرید امتیاز" />
                                            {formik.errors.cashBuyRate && formik.touched.cashBuyRate ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.cashBuyRate}</p>
                                            ) : null}
                                        </div>
                                        <div>
                                            <label for="commonBuyRate" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">قیمت عرفی خرید امتیاز</label>
                                            <Field autocomplete="off" type="text" name="commonBuyRate" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="قیمت عرفی خرید امتیاز" />
                                            {formik.errors.commonBuyRate && formik.touched.commonBuyRate ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.commonBuyRate}</p>
                                            ) : null}
                                        </div>
                                        <div>
                                            <label for="number" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">قیمت فعلی فروش نقدی</label>
                                            <Field autocomplete="off" type="text" name="number" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="قیمت فعلی فروش نقدی" />
                                            {formik.errors.number && formik.touched.number ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.number}</p>
                                            ) : null}
                                        </div>
                                        <div>
                                            <label for="chequeNumber" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">قیمت فعلی فروش چکی</label>
                                            <Field autocomplete="off" type="text" name="chequeNumber" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="قیمت فعلی فروش چکی" />
                                            {formik.errors.chequeNumber && formik.touched.chequeNumber ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.chequeNumber}</p>
                                            ) : null}
                                        </div>
                                        <div>
                                            <label for="difference" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">اختلاف قیمت ماه ها (از 24 ماه)</label>
                                            <Field autocomplete="off" type="text" name="difference" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="اختلاف قیمت ماه ها" />
                                            {formik.errors.difference && formik.touched.difference ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.difference}</p>
                                            ) : null}
                                        </div>

                                        <div className="flex items-end">
                                            <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-10 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                                تغییر
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default LoansFormula